import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=00f1a2c4&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=00f1a2c4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f1a2c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00f1a2c4')) {
      api.createRecord('00f1a2c4', component.options)
    } else {
      api.reload('00f1a2c4', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=00f1a2c4&scoped=true", function () {
      api.rerender('00f1a2c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/todo/edit.vue"
export default component.exports